import Vue from "vue";
import axios from "axios";
import store from "../store";
import { commandHandler } from "@/utils/modulesForApp"
import { getAxiosConfig } from "@/utils/traceid.js";
import reportCWS from './networkReport.js';
import {getUrlParams, compareV, getUserInfoLabel} from '../utils/utils';

const getBaseUrl = () => {
	const ip = getUrlParams('ipAndPort');
	let baseUrl = "/"
	if (ip) {
		baseUrl = ip;
	} else if (process.env.isOffline) {
		baseUrl = process.env.req;
	}
	return baseUrl;
}

const config = {
	baseURL: getBaseUrl(),
	timeout: 15000,
	headers: {
		"Content-Type": "application/json;charset=utf-8"
	}
};

commandHandler({
	type: "getAppSetting"
});

const _axios = axios.create(config);

_axios.interceptors.request.use(
	function (config) {
		config.metadata = {
			startTime: new Date()
		};
		config.headers["cmbi-lang"] = localStorage.getItem("locale") || "zh-cn";
		const customersType = store.state.home.user.account ? store.state.home.user.account.customersType : '';
		// console.log("userInfo ===>", store.state.home.user, customersType);
		if (compareV("3.5.1") && customersType) {
			config.headers["customersType"] = customersType;
		}
		if (compareV("3.5.4")) {
			const labelIds = getUserInfoLabel(store.state.user.userInfo);
            config.headers['cmbi-label'] = labelIds['cmbi-label'];
            config.headers['cmbi-account-label'] = labelIds['cmbi-account-label'];
		}
		const userId = store.state.home.user.user_id || "";
		return getAxiosConfig(userId, config);
	},
	function (error) {
		// Do something with request error
		return Promise.reject(error);
	}
);

// Add a response interceptor
_axios.interceptors.response.use(
	function (response) {
		reportCWS(response);
		// Do something with response data
		return response.data;
	},
	function (error) {
		reportCWS(error);
		// Do something with response error
		return Promise.reject(error);
	}
);

Plugin.install = function (Vue) {
	Vue.axios = _axios;
	window.axios = _axios;
	Object.defineProperties(Vue.prototype, {
		axios: {
			get() {
				return _axios;
			}
		},
		$axios: {
			get() {
				return _axios;
			}
		}
	});
};

Vue.use(Plugin);

export default Plugin;
